import { ArrowUpRight } from "lucide-react";

interface ArticleCardProps {
	id: string;
	title: string;
	category: string;
	date: string;
	image: string;
	size?: "small" | "large";
}

const ArticleCard = ({
	id,
	title,
	category,
	date,
	image,
	size = "small",
}: ArticleCardProps) => {
	return (
		<a
			href={`/article/${id}`}
			className={`group relative block rounded-[2.5rem] overflow-hidden card-hover transform-gpu ${
				size === "large" ? "col-span-1 md:col-span-2 row-span-2" : ""
			}`}
			style={{
				WebkitMaskImage: "radial-gradient(white, black)",
			}}
		>
			{/* Image container */}
			<div className="relative aspect-3/4 bg-muted">
				<img
					src={image}
					alt={`${title} - Artigo sobre ${category.toLowerCase()}`}
					width={600}
					height={800}
					loading="lazy"
					decoding="async"
					className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
				/>

				{/* Overlay gradient */}
				<div className="absolute inset-0 bg-linear-to-t from-black/70 via-black/30 to-transparent" />

				{/* Content overlay */}
				<div className="absolute inset-0 p-8 flex flex-col justify-between">
					{/* Top section - Category and Date */}
					<div className="flex items-start justify-between">
						<span className="px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-md text-xs font-medium text-white border border-white/30">
							{category}
						</span>
						<span className="px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-md text-xs font-medium text-white border border-white/30">
							{date}
						</span>
					</div>

					{/* Bottom section - Title and Arrow */}
					<div className="flex items-end justify-between gap-4">
						<div className="flex-1">
							<span className="text-white/50 text-xs font-medium tracking-wider block mb-3">
								{id}
							</span>
							<h3 className="text-white text-lg md:text-xl lg:text-2xl font-bold leading-tight tracking-tight">
								{title}
							</h3>
						</div>
					</div>
				</div>

				{/* Floating circular arrow button - positioned outside content overlay */}
				<div className="absolute bottom-6 right-6 floating-button">
					<ArrowUpRight className="w-5 h-5" />
				</div>
			</div>
		</a>
	);
};

export default ArticleCard;
